import React from 'react'
export default function TrendUp({ className, style }) {
  return (
    <svg className={className} width="1em" height="1em" style={{ verticalAlign: '-0.125em', ...style }}
      viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8"
      strokeLinecap="round" strokeLinejoin="round">
      <path d="m3 17 6-6 4 4 8-8" />
      <path d="M15 7h6v6" />
    </svg>
  )
}
